<div class="modal-body" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static" id="errorContent">
    <div class="modal-content1" id="errorModel">
        <strong id="error-title" class="error-style">{{errorName}}</strong>
        <p id="error-description" class="error-style1" [style.white-space]="'pre-line'" >{{errorDescription}}</p>
        <button id="error-confirm-btn" type="button" class="btn" (click)="[activeModal.close(true)]">{{confirmBtnText}}</button>
        @if (showCancelButton) {
            <button id="error-dismiss-btn" type="button" class="btn1" (click)="[activeModal.close(false)]">Dismiss</button>
        }
    </div>
</div>
